import { defineStore } from 'pinia'

export const useFormatsStore = defineStore('formats', {
  state: () => ({
    items: ['In-person', 'Online'],
  })
})